module.exports = __webpack_public_path__ + "static/media/BigCaslon.eb2c1579.otf";